import { render, staticRenderFns } from "./screeningHome.vue?vue&type=template&id=7b62fb7f&scoped=true&"
import script from "./screeningHome.vue?vue&type=script&lang=js&"
export * from "./screeningHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b62fb7f",
  null
  
)

export default component.exports